import React from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import ComplianceKpiCards from './ComplianceKpiCards';
import ComplianceSummaryDonut from './ComplianceSummaryDonut';
import TopRejectionReasonsCard from './TopRejectionReasonsCard';
import { useTranslatedMessages } from '../../../../hooks/useTranslatedMessages';

const ComplianceTab = ({ complianceData, loading = false }) => {
  const { misDashboard: m } = useTranslatedMessages();

  if (!loading && !complianceData) {
    return (
      <Paper variant="outlined" sx={{ p: 3, borderRadius: 2 }}>
        <Typography color="text.secondary">
          {m.compliance?.no_data ?? 'No compliance data available for the selected filters.'}
        </Typography>
      </Paper>
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, lg: 6 }} sx={{ display: 'flex' }}>
        <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, height: '100%', width: '100%' }}>
          <ComplianceKpiCards summary={complianceData?.summary} />
          <ComplianceSummaryDonut byStatus={complianceData?.by_status} loading={loading} />
        </Paper>
      </Grid>
      <Grid size={{ xs: 12, lg: 6 }} sx={{ display: 'flex' }}>
        <TopRejectionReasonsCard reasons={complianceData?.top_rejection_reasons ?? []} loading={loading} />
      </Grid>
    </Grid>
  );
};

export default ComplianceTab;
